var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"home"},[_c('c-banner'),_c('c-about'),_c('c-news'),_c('c-word-grexy'),_c('c-update-section'),_c('c-game'),_c('c-benefits')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }